import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// nový loader bez gif

const BOOKS = [
  { id: 'book-left', x: 42, y: 26, width: 24, height: 80, delay: '0s', opacity: 0.72 },
  { id: 'book-mid-left', x: 70, y: 34, width: 24, height: 72, delay: '0.1s', opacity: 0.82 },
  { id: 'book-mid-right', x: 98, y: 31, width: 24, height: 75, delay: '0.2s', opacity: 0.92 },
  { id: 'book-right', x: 126, y: 36, width: 24, height: 70, delay: '0.3s', opacity: 0.8 },
];

export default function GiffLoader() {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const surface = theme.palette.background.paper ?? '#FFFFFF';
  const divider = theme.palette.divider;

  return (
    <Box sx={{ width: 300, maxWidth: '100%', mx: 'auto', py: 1.5 }}>
      <Box
        component="svg"
        viewBox="0 0 240 150"
        role="status"
        aria-label="Loading"
        sx={{ display: 'block', width: '100%', height: 'auto' }}
      >
        <title>Loading</title>
        <line
          x1="18"
          y1="114"
          x2="222"
          y2="114"
          stroke={primary}
          strokeWidth="3"
          strokeLinecap="round"
        />

        {BOOKS.map((book) => (
          <g key={book.id} transform={`translate(${book.x} ${book.y})`}>
            <g>
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; 0 4; 0 0"
                dur="1.6s"
                begin={book.delay}
                repeatCount="indefinite"
              />
              <rect
                x="0"
                y="0"
                width={book.width}
                height={book.height}
                rx="9"
                fill={primary}
                fillOpacity={book.opacity}
                stroke={primary}
                strokeOpacity="0.92"
                strokeWidth="2"
              />
              <rect x="4.5" y="11" width="15" height="3.2" rx="1.6" fill={surface} fillOpacity="0.95" />
              <rect x="4.5" y="19" width="15" height="3.2" rx="1.6" fill={surface} fillOpacity="0.95" />
              <rect
                x="4"
                y={book.height - 18}
                width="16"
                height="12"
                rx="4"
                fill={surface}
                fillOpacity="0.96"
                stroke={divider}
                strokeOpacity="0.6"
              />
            </g>
          </g>
        ))}

        <g transform="translate(154 87)">
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 0 18; 5 0 18; 0 0 18"
              dur="1.9s"
              repeatCount="indefinite"
            />
            <path
              d="M0 0 C14 0 30 4 46 14 L56 20 C53 28 46 33 36 33 H0 Z"
              fill={primary}
              fillOpacity="0.9"
            />
          </g>
        </g>
      </Box>
    </Box>
  );
}
